import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/reasonToBeBusy'),
      component: SettingsContent,
      props: {
        headerTitle: 'REASONS_TO_BE_BUSY.HEADER',
        icon: 'pause-circle',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'reason_to_be_busy_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'reason_to_be_busy_list',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
